import React from "react";
import "./Orange_btn.css"
import { Button } from "react-bootstrap";

function Orange_btn({ btn_text,onClick }) {
  return (
    <>
      <section className="Orange_btn_holder">
        <Button className="Orange_btn" type="button" onClick={onClick}>
          {btn_text}
        </Button>
      </section>
    </>
  );
}

export default Orange_btn;
